export function hasModule(user, code) {
  const modules = user?.modules || [];
  console.log(
    'Checking module access for',
    code,
    'against user modules',
    modules
  );
  const normalized = modules.map((m) => m.toLowerCase());

  return normalized.includes(code) || normalized.includes('all');
}
